import React, { Component } from "react";
import {
  Box,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Text,
  TableCell
} from "grommet";

export class PatrolsTable extends Component {
  state = {
    tableRows: []
  };

  getPrettyDateString = dateString => {
    const firstArray = dateString.split("T");
    const timeString = firstArray[1];
    const secondArray = timeString.split("+");
    return secondArray[0];
  };

  getTimeDifference = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const difference = new Date(end - start);

    let differenceString = difference.toISOString().substr(11, 8);
    const diffArray = differenceString.split(":");
    if (diffArray[0] === "00") {
      differenceString = diffArray[1] + ":" + diffArray[2];
    }
    return differenceString;
  };

  updateTableRows = shiftGuards => {
    let tableRows = [];

    shiftGuards.forEach(shiftGuard => {
      const roleInstances = shiftGuard.RoleInstances;
      if (typeof roleInstances == "object") {
        roleInstances.forEach(roleInstance => {
          const role = roleInstance.Role;
          let tableRowElement;

          const timeStart = this.getPrettyDateString(roleInstance.timeStart);
          const DateTimeEnd = this.getPrettyDateString(
            roleInstance.DateTimeEnd
          );
          if (role.Type === "Patrol") {
            let patrolPointsReached = roleInstance.RouteInstances.length - 1;
            if (patrolPointsReached === -1) {
              patrolPointsReached = 0;
            }
            tableRowElement = {
              guardName: shiftGuard.Gaurd.GaurdFirstName,
              patrolStartTime: timeStart,
              patrolEndTime: DateTimeEnd,
              timePatrolling: this.getTimeDifference(
                roleInstance.timeStart,
                roleInstance.DateTimeEnd
              ),
              patrolPointsReached: patrolPointsReached
            };
            tableRows.push(tableRowElement);
          }
        });
      }
    });
    const newState = {
      ...this.state,
      tableRows: tableRows
    };
    this.setState(newState);
  };

  componentDidMount = () => {
    this.updateTableRows(this.props.shiftData.Shift_Gaurds);
  };
  render() {
    const tableRows = this.state.tableRows;

    return (
      <Box direction="column" alignContent="center">
        <Table alignSelf="center">
          <TableHeader>
            <TableRow>
              <TableCell scope="col" border="bottom">
                Guard Name
              </TableCell>
              <TableCell scope="col" border="bottom">
                Patrol Start Time
              </TableCell>
              <TableCell scope="col" border="bottom">
                Patrol End Time
              </TableCell>
              <TableCell scope="col" border="bottom">
                Time Patrolling
              </TableCell>
              <TableCell scope="col" border="bottom">
                Patrol Points Reached
              </TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {tableRows.map((tableRow, index) => {
              return (
                <TableRow key={index}>
                  <TableCell scope="row">
                    <Text>{tableRow.guardName}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.patrolStartTime}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.patrolEndTime}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.timePatrolling}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.patrolPointsReached}</Text>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    );
  }
}

export default PatrolsTable;
